import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const AgendaInfoIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M14 4V6.59971C13.2499 6.21628 12.4002 6 11.5 6C8.46243 6 6 8.46243 6 11.5C6 12.4002 6.21628 13.2499 6.59971 14H2.5C1.11929 14 0 12.8807 0 11.5V4H14ZM11.5 0C12.8807 0 14 1.11929 14 2.5V3H0V2.5C0 1.11929 1.11929 0 2.5 0H11.5ZM10.875 9.5C10.875 9.15482 11.1548 8.875 11.5 8.875C11.8452 8.875 12.125 9.15482 12.125 9.5C12.125 9.84518 11.8452 10.125 11.5 10.125C11.1548 10.125 10.875 9.84518 10.875 9.5ZM12 13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5V13.5ZM7 11.5C7 9.01472 9.01472 7 11.5 7C13.9853 7 16 9.01472 16 11.5C16 13.9853 13.9853 16 11.5 16C9.01472 16 7 13.9853 7 11.5ZM8 11.5C8 13.433 9.567 15 11.5 15C13.433 15 15 13.433 15 11.5C15 9.567 13.433 8 11.5 8C9.567 8 8 9.567 8 11.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default AgendaInfoIcon;
